// Code generated by gosaas codegen frontend; DO NOT EDIT.

/** Resolved auth.oauth flags (omitted YAML branches default true when auth is on). */
export type AuthOAuthSubmodule = {
	enabled: boolean;
	google: boolean;
	github: boolean;
};

/** Auth module tree; add more keys here as backend submodules grow. */
export type AuthSubmodule = {
	enabled: boolean;
	oauth: AuthOAuthSubmodule;
	/** Staff admin console (auth.staff; omitted defaults true when auth is on). */
	staff: boolean;
};

/** Operations submodules for public legal and security surfaces. */
export type OperationsSubmodule = {
	enabled: boolean;
	legal: boolean;
	security: boolean;
};

/** Billing submodule flags from modules.yaml. */
export type BillingFreeTrialSubmodule = {
	enabled: boolean;
	days: number;
};

export type BillingDefaultPaidPlanSubmodule = {
	plan: string;
	/** @deprecated Use plan. Kept for modules.yaml backward compatibility. */
	individual: string;
	/** @deprecated Use plan. Kept for modules.yaml backward compatibility. */
	team: string;
};

export type BillingSubmodule = {
	enabled: boolean;
	free_tier: boolean;
	free_trial: BillingFreeTrialSubmodule;
	default_paid_plan: BillingDefaultPaidPlanSubmodule;
	/** Plan-based API quotas, rate limits, and query add-ons (billing.api_pricing). */
	api_pricing: boolean;
};

/** Per-language integrator clients under public_api.clients. */
export type PublicAPIClientsSubmodule = {
	typescript: boolean;
	go: boolean;
	python: boolean;
	php: boolean;
	ruby: boolean;
	zapier: boolean;
};

/** Public API integrator surface (/api/v1, API keys, client packages). */
export type PublicAPISubmodule = {
	enabled: boolean;
	mcp: boolean;
	clients: PublicAPIClientsSubmodule;
};

export type ModulesConfig = {
	auth: AuthSubmodule;
	team: boolean;
	billing: BillingSubmodule;
	notifications: boolean;
	feedback: boolean;
	marketing_blog: boolean;
	marketing_changelog: boolean;
	mobile_app: boolean;
	public_api: PublicAPISubmodule;
	docs: boolean;
	knowledge_base: boolean;
	operations: OperationsSubmodule;
};

export type ModuleId = keyof ModulesConfig;

export const MODULES: ModulesConfig = {
	auth: {
		enabled: false,
		oauth: {
			enabled: false,
			google: false,
			github: false,
		},
		staff: false,
	},
	team: false,
	billing: {
		enabled: false,
		free_tier: true,
		free_trial: {
			enabled: false,
			days: 0,
		},
		default_paid_plan: {
			plan: "Personal",
			individual: "Personal",
			team: "Personal",
		},
		api_pricing: false,
	},
	notifications: false,
	feedback: true,
	marketing_blog: false,
	marketing_changelog: true,
	mobile_app: false,
	public_api: {
		enabled: false,
		mcp: false,
		clients: {
			typescript: false,
			go: false,
			python: false,
			php: false,
			ruby: false,
			zapier: false,
		},
	},
	docs: false,
	knowledge_base: false,
	operations: {
		enabled: false,
		legal: false,
		security: false,
	},
};
